﻿interface SetSpeedProps {
    value: number;
    previousElementSibling: HTMLAudioElement;
}

class LazyAudio {
    static renderBlock({ target }: { target: HTMLButtonElement }) {
        const unicId = `audio-${Date.now()}`;
        const btn = target.closest('.fake-audio');

        if (btn) {
            btn.outerHTML = `
                <div class="audio-container">
                    <audio id="${unicId}" preload="metadata" controls>
                        <source src="${btn.getAttribute('data-src')}" type="audio/mpeg">
                    </audio>

                    ${btn.querySelector('.fake-audio-speed-select') ? `
                        <select class='audio-speed-select' onchange='LazyAudio.setSpeed(this)'>
                            <option value="1">1x</option>
                            <option value="1.25">1.25x</option>
                            <option value="1.5">1.5x</option>
                            <option value="1.75">1.75x</option>
                            <option value="2">2x</option>
                            <option value="3">3x</option>
                            <option value="4">4x</option>
                        </select>
                    ` : ''}
                </div>
            `;

            const newAudioElement = document.getElementById(unicId) as HTMLAudioElement;
            newAudioElement.currentTime = Number(btn.getAttribute('data-start'));

            if (target.classList.contains('fake-audio__play')) {
                newAudioElement.addEventListener('canplaythrough', () => {
                    void newAudioElement.play();
                });
            }
        }
    }

    static getTime(sec: number) {
        if (sec) {
            const seconds = sec % 60;
            return `${Math.floor(sec / 60)}:${seconds > 9 ? seconds : `0${seconds}`}`;
        }
        return '0:00';
    }

    static setSpeed({ value, previousElementSibling }: SetSpeedProps) {
        previousElementSibling.playbackRate = +value;
    }
}

window.LazyAudio = LazyAudio;
